export function formatStationDistanceMeters(meters: number): string {
  if (meters >= 1000) {
    const kilometres = meters / 1000;
    const rounded = kilometres >= 10 ? Math.round(kilometres) : Number(kilometres.toFixed(1));
    return `${rounded} km`;
  }

  return `${meters} m`;
}
